module.exports = [
    {
        name: 'CX-5',
        nicename: 'cx5',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885847&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037106/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885847&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX5_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885869&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037216/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885869&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX5_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885854&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885854&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037242/skeleton.gif'
            }
        }
    }
];


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/constants/minivan.js
// module id = 62
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14